export const MAX_FILE_SIZE = 540000;

export const MAX_RESUME_PDF_SIZE = 1000000;

export const PAGE_SIZE : number = 10; 

export const Thank_You = "We have received your request... Our team will get back to you soon!, Thank You!";

export const Something_went_wrong = "Please try again!, Something went wrong!";

export const Unsupported_file_format = "Unsupported file format";

export const Maximum_file_upload_size_should_be_1MB = "Maximum file upload size should be 1MB";

export const No_branches_are_available_for_Selected_State = "No branches are available for Selected State";

export const No_data_found_for_the_selected_city = "No data found for the selected city!";

export const Please_select_From_Date_and_To_Date = "Please select From Date and To Date";

export const From_date  = "Please select a valid From date";

export const To_date = "Please select a valid To date";

export const Request_Thank_You = "We received your request!, Thank You!";

export const Please_select_value_that_is_no_less_than_500 = 'Please select a value that is no less than 500.';

export const Select_value_no_more_than_10000000 = 'Please select a value that is no more than 10000000';

export const Valid_inputs = 'Please provide valid inputs';

export const Less_than_10000 = 'Please select a value that is no less than 10000.';

export const More_than_10000000000 = 'Please select a value that is no more than 10000000000';

export const reload_page_Something_went_wrong = "Please try to reload the page, Something went wrong!";

export const MONTH_LIST = [
    { value: 1, month: 'Jan' },
    { value: 2, month: 'Feb' },
    { value: 3, month: 'Mar' },
    { value: 4, month: 'Apr' },
    { value: 5, month: 'May' },
    { value: 6, month: 'June' },
    { value: 7, month: 'July' },
    { value: 8, month: 'Aug' },
    { value: 9, month: 'Sep' },
    { value: 10, month: 'Oct' },
    { value: 11, month: 'Nov' },
    { value: 12, month: 'Dec' }
];

export const YEAR_LIST = 
[
    {
        year:"2019"
    },
    {
        year:"2020"
    },
    {
        year:"2020-2021"
    },
    {
        year:"2019-2020"
    },
    {
        year:"2021"
    }
];

export const CEO_TAB_LIST = [ "Article", "Videos","CEO Insights", "CEO-Interview", "New Developments", "Latest News", "Message to Partners"];
